import React, { useState, useRef, useEffect } from "react";
import html2pdf from "html2pdf.js";
import Fotter from "../components/Fotter";
import AdminSidebar from "../components/AdminSidebar";
import { FaDownload, FaPrint, FaEdit, FaTrash } from 'react-icons/fa';

// Import BASE_URL from your backend configuration
import { BASE_URL } from "../backend/backend.js";

const billingPageStyles = {
  container: { display: 'flex', backgroundColor: '#f4f6f8', minHeight: '100vh' },
  card: { backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)', margin: '30px auto', padding: '30px', width: '90%', maxWidth: '700px', transition: 'transform 0.3s ease-in-out', perspective: '1000px' },
  cardHover: { transform: 'translateY(-5px) rotateX(2deg) rotateY(5deg)', boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)' },
  header: { textAlign: 'center', marginBottom: '30px' },
  title: { color: '#2c3e50', fontSize: '2.5rem', marginBottom: '5px', letterSpacing: '1px' },
  subtitle: { color: '#7f8c8d', fontSize: '1.1rem' },
  infoSection: { display: 'grid', gap: '20px', marginBottom: '25px' },
  infoSectionDesktop: { gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))' },
  medicineSelection: { display: 'grid', gap: '20px', marginBottom: '25px', gridTemplateColumns: '1fr' },
  medicineSelectionDesktop: { gridTemplateColumns: '1fr 1fr' },
  label: { display: 'block', fontSize: '1rem', color: '#34495e', marginBottom: '8px', fontWeight: '500' },
  input: { width: '100%', padding: '12px', fontSize: '1rem', border: '1px solid #bdc3c7', borderRadius: '8px', marginBottom: '15px', boxSizing: 'border-box', transition: 'border-color 0.3s ease' },
  inputFocus: { borderColor: '#3498db', outline: 'none', boxShadow: '0 0 5px rgba(52, 152, 219, 0.5)' },
  addButton: { width: '100%', padding: '15px', fontSize: '1.1rem', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'background-color 0.3s ease', marginBottom: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', backgroundColor: '#3498db' },
  addButtonHover: { backgroundColor: '#2980b9' },
  paymentSelection: { marginBottom: '20px' },
  paymentLabel: { display: 'block', fontSize: '1rem', color: '#34495e', marginBottom: '8px', fontWeight: '500' },
  paymentRadioGroup: { display: 'flex', gap: '20px' },
  paymentRadioLabel: { display: 'flex', alignItems: 'center', fontSize: '1rem', color: '#555', cursor: 'pointer' },
  paymentRadioInput: { marginRight: '8px' },
  actionsContainer: { display: 'flex', gap: '10px', marginBottom: '20px', justifyContent: 'flex-end' },
  iconButton: { background: 'none', border: 'none', color: '#555', fontSize: '1.5rem', cursor: 'pointer', outline: 'none', padding: '8px', borderRadius: '50%', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', transition: 'background-color 0.3s ease, color 0.3s ease' },
  iconButtonHover: { backgroundColor: '#f0f0f0', color: '#333' },
  billPreview: { backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)', marginBottom: '20px', border: '1px solid #eee' },
  billHeader: { marginBottom: '15px' },
  companyInfo: { textAlign: 'left', marginBottom: '10px' },
  companyName: { color: '#34495e', fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '3px' },
  companyTagline: { color: '#7f8c8d', fontSize: '0.9rem' },
  billInfo: { textAlign: 'left' },
  billNumber: { color: '#34495e', fontSize: '1rem', marginBottom: '3px' },
  billDateTime: { color: '#7f8c8d', fontSize: '0.9rem', marginBottom: '3px' },
  billCustomerInfo: { color: '#7f8c8d', fontSize: '1rem', marginBottom: '3px' },
  billPaymentInfo: { color: '#34495e', fontSize: '1rem', marginTop: '10px', fontWeight: 'bold' },
  billTable: { width: '100%', borderCollapse: 'collapse', marginTop: '15px' },
  tableHeader: { backgroundColor: '#ecf0f1', color: '#34495e', padding: '10px', textAlign: 'left', borderBottom: '2px solid #bdc3c7', fontWeight: 'bold' },
  tableData: { padding: '10px', borderBottom: '1px solid #eee' },
  totalRow: { fontWeight: 'bold', backgroundColor: '#f0f3f4' },
  totalLabel: { padding: '10px', textAlign: 'right' },
  totalAmount: { padding: '10px' },
  editDeleteActions: { display: 'flex', gap: '5px', justifyContent: 'center' },
  editDeleteButton: { background: 'none', border: 'none', color: '#555', fontSize: '1rem', cursor: 'pointer', outline: 'none', padding: '5px', borderRadius: '5px', transition: 'background-color 0.3s ease, color 0.3s ease' },
  editButtonHover: { backgroundColor: '#e0f7fa', color: '#00bcd4' },
  deleteButtonHover: { backgroundColor: '#ffebee', color: '#f44336' },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '500px',
    width: '90%',
  },
  modalTitle: {
    color: '#2c3e50',
    fontSize: '1.5rem',
    marginBottom: '15px',
    textAlign: 'center',
  },
  modalLabel: {
    display: 'block',
    fontSize: '1rem',
    color: '#34495e',
    marginBottom: '8px',
    fontWeight: '500',
  },
  modalInput: {
    width: '100%',
    padding: '10px',
    fontSize: '1rem',
    border: '1px solid #bdc3c7',
    borderRadius: '8px',
    marginBottom: '15px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s ease',
  },
  modalActions: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
  },
  modalButton: {
    padding: '10px 15px',
    fontSize: '1rem',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  },
  modalUpdateButton: {
    backgroundColor: '#3498db',
  },
  modalUpdateButtonHover: {
    backgroundColor: '#2980b9',
  },
  modalCancelButton: {
    backgroundColor: '#95a5a6',
  },
  modalCancelButtonHover: {
    backgroundColor: '#7f8c8d',
  },
  billTableActions: {
    display: 'flex',
    justifyContent: 'center',
  },
};

export default function MakeBillPage() {
  const [medicines, setMedicines] = useState([]);
  const [selectedMedicineId, setSelectedMedicineId] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [billItems, setBillItems] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [customerNumber, setCustomerNumber] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [billNumber, setBillNumber] = useState(`BILL-${Date.now().toString().slice(-6)}`);
  const billRef = useRef();
  const [isCardHovered, setIsCardHovered] = useState(false);
  const [billDateTime, setBillDateTime] = useState(new Date().toLocaleString());
  const [paymentMode, setPaymentMode] = useState("cash");
  const [editingItemId, setEditingItemId] = useState(null);
  const [editQuantity, setEditQuantity] = useState(1);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMedicines = async () => {
      try {
        // Replaced hardcoded localhost URL with BASE_URL template literal
        const response = await fetch(`${BASE_URL}/api/getAllMedicine`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setMedicines(data.body || []);
        setLoading(false);
      } catch (e) {
        setError(e);
        setLoading(false);
      }
    };

    fetchMedicines();
  }, []);

  const selectedMedicine = medicines.find(m => m.id === parseInt(selectedMedicineId));
  const getDiscountedPrice = (med) => parseFloat((med.price - (med.price * med.discountPercentage) / 100).toFixed(2));
  const getDiscountAmount = (med) => parseFloat((med.price * med.discountPercentage / 100).toFixed(2));

  const addToBill = () => {
    if (selectedMedicine && quantity > 0) {
      const discountedPrice = getDiscountedPrice(selectedMedicine);
      const discountAmount = getDiscountAmount(selectedMedicine);
      setBillItems([...billItems, {
        id: selectedMedicine.id,
        name: selectedMedicine.medicineName,
        price: selectedMedicine.price,
        discountPercent: selectedMedicine.discountPercentage,
        discountPrice: discountAmount,
        quantity,
        total: parseFloat((discountedPrice * quantity).toFixed(2))
      }]);
      setQuantity(1);
      setSelectedMedicineId("");
      setBillDateTime(new Date().toLocaleString());
    }
  };

  const removeItem = (id) => {
    setBillItems(billItems.filter(item => item.id !== id));
    setBillDateTime(new Date().toLocaleString());
  };

  const openEditModal = (item) => {
    setEditingItemId(item.id);
    setEditQuantity(item.quantity);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingItemId(null);
  };

  const updateItemQuantity = () => {
    setBillItems(billItems.map(item =>
      item.id === editingItemId
        ? { ...item, quantity: parseInt(editQuantity), total: parseFloat((getDiscountedPrice(medicines.find(med => med.id === item.id)) * parseInt(editQuantity)).toFixed(2)) }
        : item
    ));
    closeEditModal();
    setBillDateTime(new Date().toLocaleString());
  };

  const generatePDF = () => {
    const element = billRef.current.cloneNode(true);
    const actionColumn = element.querySelectorAll('.bill-actions');
    actionColumn.forEach(col => col.remove());

    const options = { margin: 10, filename: `Bill_${billNumber}.pdf`, image: { type: 'jpeg', quality: 0.98 }, html2canvas: { scale: 2 }, jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' } };
    html2pdf().from(element).set(options).save();
  };

  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Bill</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .bill-header { text-align: center; margin-bottom: 15px; }
            .company-info { text-align: left; margin-bottom: 10px; }
            .company-name { color: #34495e; font-size: 1.2rem; font-weight: bold; margin-bottom: 3px; }
            .company-tagline { color: #7f8c8d; font-size: 0.9rem; }
            .bill-info { text-align: left; }
            .bill-number, .bill-dateTime, .bill-customer-info, .bill-payment-info { color: #34495e; font-size: 1rem; margin-bottom: 3px; }
            .bill-payment-info { margin-top: 10px; font-weight: bold; }
            .bill-table { width: 100%; border-collapse: collapse; margin-top: 15px; }
            .table-header { background-color: #ecf0f1; color: #34495e; padding: 10px; text-align: left; border-bottom: 2px solid #bdc3c7; font-weight: bold; }
            .table-data { padding: 10px; border-bottom: 1px solid #eee; }
            .total-row { font-weight: bold; background-color: #f0f3f4; }
            .total-label { padding: 10px; text-align: right; }
            .total-amount { padding: 10px; }
          </style>
        </head>
        <body>
          <div class="bill-preview">
            <div class="bill-header">
              <div class="company-info">
                <h3 class="company-name">Girraj Medicare</h3>
                <p class="company-tagline">( Your trusted Medicare from last 25 years )</p>
              </div>
              <div class="bill-info">
                <p class="bill-number">Bill No: ${billNumber}</p>
                <p class="bill-dateTime">Date & Time: ${billDateTime}</p>
                <p class="bill-customer-info">Name: ${customerName}</p>
                <p class="bill-customer-info">Phone: ${customerNumber}</p>
                <p class="bill-customer-info">Address: ${customerAddress}</p>
              </div>
            </div>

            <table class="bill-table">
              <thead>
                <tr>
                  <th class="table-header">Medicine</th>
                  <th class="table-header">Price (₹)</th>
                  <th class="table-header">Discount (%)</th>
                  <th class="table-header">Discount Price (₹)</th>
                  <th class="table-header">Quantity</th>
                  <th class="table-header">Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                ${billItems.map(item => `
                  <tr>
                    <td class="table-data">${item.name}</td>
                    <td class="table-data">₹${item.price.toFixed(2)}</td>
                    <td class="table-data">${item.discountPercent}%</td>
                    <td class="table-data">₹${item.discountPrice.toFixed(2)}</td>
                    <td class="table-data">${item.quantity}</td>
                    <td class="table-data">₹${item.total.toFixed(2)}</td>
                  </tr>
                `).join('')}
                ${billItems.length > 0 ? `
                  <tr class="total-row">
                    <td colspan="5" class="total-label">Total:</td>
                    <td class="total-amount">₹${billItems.reduce((sum, item) => sum + item.total, 0).toFixed(2)}</td>
                  </tr>
                ` : ''}
              </tbody>
            </table>
            ${billItems.length > 0 ? `
              <p class="bill-payment-info">Payment Mode: ${paymentMode === 'cash' ? 'Cash' : 'Online'}</p>
            ` : ''}
          </div>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  if (loading) {
    return <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100vh'}}>Loading medicines...</div>;
  }

  if (error) {
    return <div style={{color:'red', textAlign:'center', marginTop:'50px'}}>Error fetching medicines: {error.message}</div>;
  }

  return (
    <div style={billingPageStyles.container}>
      <AdminSidebar />
      <div
        style={{ ...billingPageStyles.card, ...(isCardHovered ? billingPageStyles.cardHover : {}) }}
        onMouseEnter={() => setIsCardHovered(true)}
        onMouseLeave={() => setIsCardHovered(false)}
      >
        <div style={billingPageStyles.header}>
          <h2 style={billingPageStyles.title}>New Generation Billing</h2>
          <p style={billingPageStyles.subtitle}>Effortlessly generate and manage your bills.</p>
        </div>

        <div style={{ ...billingPageStyles.infoSection, ...(window.innerWidth >= 576 ? billingPageStyles.infoSectionDesktop : {}) }}>
          <div><label style={billingPageStyles.label}>Customer Name:</label><input type="text" value={customerName} onChange={(e) => setCustomerName(e.target.value)} style={{ ...billingPageStyles.input, ...(customerName && billingPageStyles.inputFocus) }} placeholder="Enter customer name" /></div>
          <div><label style={billingPageStyles.label}>Customer Phone:</label><input type="text" value={customerNumber} onChange={(e) => setCustomerNumber(e.target.value)} style={{ ...billingPageStyles.input, ...(customerNumber && billingPageStyles.inputFocus) }} placeholder="Enter phone number" /></div>
          <div><label style={billingPageStyles.label}>Customer Address:</label><input type="text" value={customerAddress} onChange={(e) => setCustomerAddress(e.target.value)} style={{ ...billingPageStyles.input, ...(customerAddress && billingPageStyles.inputFocus) }} placeholder="Enter address" /></div>
        </div>

        <div style={{ ...billingPageStyles.medicineSelection, ...(window.innerWidth >= 576 ? billingPageStyles.medicineSelectionDesktop : {}) }}>
          <div>
            <label style={billingPageStyles.label}>Select Medicine:</label>
            <select value={selectedMedicineId} onChange={(e) => setSelectedMedicineId(e.target.value)} style={{ ...billingPageStyles.input, appearance: 'none' }}>
              <option value="">-- Select Medicine --</option>
              {medicines.map(medicine => (
                <option key={medicine.id} value={medicine.id}>{medicine.medicineName} - ₹{(medicine.price).toFixed(2)} ({medicine.discountPercentage}% off)</option>
              ))}
            </select>
          </div>
          <div>
            <label style={billingPageStyles.label}>Quantity:</label>
            <input type="number" value={quantity} onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value)))} min="1" style={{ ...billingPageStyles.input, ...(quantity > 0 && billingPageStyles.inputFocus) }} />
          </div>
        </div>

        <button onClick={addToBill} style={{ ...billingPageStyles.button, ...billingPageStyles.addButton }} onMouseEnter={(e) => Object.assign(e.target.style, billingPageStyles.addButtonHover)} onMouseLeave={(e) => Object.assign(e.target.style, billingPageStyles.addButton)}>Add to Bill</button>

        <div style={billingPageStyles.paymentSelection}>
          <label style={billingPageStyles.paymentLabel}>Payment Mode:</label>
          <div style={billingPageStyles.paymentRadioGroup}>
            <label style={billingPageStyles.paymentRadioLabel}>
              <input
                type="radio"
                name="paymentMode"
                value="cash"
                checked={paymentMode === "cash"}
                onChange={(e) => setPaymentMode(e.target.value)}
                style={billingPageStyles.paymentRadioInput}
              />
              Cash
            </label>
            <label style={billingPageStyles.paymentRadioLabel}>
              <input
                type="radio"
                name="paymentMode"
                value="online"
                checked={paymentMode === "online"}
                onChange={(e) => setPaymentMode(e.target.value)}
                style={billingPageStyles.paymentRadioInput}
              />
              Online
            </label>
          </div>
        </div>

        <div ref={billRef} style={billingPageStyles.billPreview}>
          <div style={billingPageStyles.billHeader}>
            <div style={billingPageStyles.companyInfo}>
              <h3 style={billingPageStyles.companyName}>Girraj Medicare</h3>
              <p style={billingPageStyles.companyTagline}>( Your trusted Medicare from last 25 years )</p>
            </div>
            <div style={billingPageStyles.billInfo}>
              <p style={billingPageStyles.billNumber}>Bill No: {billNumber}</p>
              <p style={billingPageStyles.billDateTime}>Date & Time: {billDateTime}</p>
              <p style={billingPageStyles.billCustomerInfo}>Name: {customerName}</p>
              <p style={billingPageStyles.billCustomerInfo}>Phone: {customerNumber}</p>
              <p style={billingPageStyles.billCustomerInfo}>Address: {customerAddress}</p>
            </div>
          </div>

          <table style={billingPageStyles.billTable}>
            <thead>
              <tr>
                <th style={billingPageStyles.tableHeader}>Medicine</th>
                <th style={billingPageStyles.tableHeader}>Price (₹)</th>
                <th style={billingPageStyles.tableHeader}>Discount (%)</th>
                <th style={billingPageStyles.tableHeader}>Discount Price (₹)</th>
                <th style={billingPageStyles.tableHeader}>Quantity</th>
                <th style={billingPageStyles.tableHeader}>Total (₹)</th>
                <th style={billingPageStyles.tableHeader}></th>
              </tr>
            </thead>
            <tbody>
              {billItems.map(item => (
                <tr key={item.id}>
                  <td style={billingPageStyles.tableData}>{item.name}</td>
                  <td style={billingPageStyles.tableData}>₹{(item.price).toFixed(2)}</td>
                  <td style={billingPageStyles.tableData}>{item.discountPercent}%</td>
                  <td style={billingPageStyles.tableData}>₹{(item.discountPrice).toFixed(2)}</td>
                  <td style={billingPageStyles.tableData}>{item.quantity}</td>
                  <td style={billingPageStyles.tableData}>₹{(item.total).toFixed(2)}</td>
                  <td style={billingPageStyles.tableData} className="bill-actions">
                    <div style={billingPageStyles.editDeleteActions}>
                      <button
                        onClick={() => openEditModal(item)}
                        style={{ ...billingPageStyles.editDeleteButton, ...billingPageStyles.editButtonHover }}
                      >
                        <FaEdit />
                      </button>
                      <button
                        onClick={() => removeItem(item.id)}
                        style={{ ...billingPageStyles.editDeleteButton, ...billingPageStyles.deleteButtonHover }}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {billItems.length > 0 && (
                <tr style={billingPageStyles.totalRow}>
                  <td colSpan="5" style={billingPageStyles.totalLabel}>Total:</td>
                  <td style={billingPageStyles.totalAmount}>₹{(billItems.reduce((sum, item) => sum + item.total, 0)).toFixed(2)}</td>
                  <td className="bill-actions"></td>
                </tr>
              )}
            </tbody>
          </table>
          {billItems.length > 0 && (
            <p style={billingPageStyles.billPaymentInfo}>Payment Mode: {paymentMode === 'cash' ? 'Cash' : 'Online'}</p>
          )}
        </div>

        <div style={billingPageStyles.actionsContainer}>
          <button onClick={generatePDF} style={billingPageStyles.iconButton}><FaDownload /></button>
          <button onClick={handlePrint} style={billingPageStyles.iconButton}><FaPrint /></button>
        </div>
      </div>

      {isEditModalOpen && (
        <div style={billingPageStyles.modalOverlay}>
          <div style={billingPageStyles.modalContent}>
            <h2 style={billingPageStyles.modalTitle}>Edit Quantity</h2>
            <label htmlFor="editQuantity" style={billingPageStyles.modalLabel}>Quantity:</label>
            <input
              type="number"
              id="editQuantity"
              value={editQuantity}
              onChange={(e) => setEditQuantity(Math.max(1, parseInt(e.target.value)))}
              min="1"
              style={billingPageStyles.modalInput}
            />
            <div style={billingPageStyles.modalActions}>
              <button
                onClick={updateItemQuantity}
                style={{ ...billingPageStyles.modalButton, ...billingPageStyles.modalUpdateButton }}
              >
                Update
              </button>
              <button
                onClick={closeEditModal}
                style={{ ...billingPageStyles.modalButton, ...billingPageStyles.modalCancelButton }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}